import React from "react"
import "./code.scss"

const Code = ({ plainText }) => (
  <div className="Code" dangerouslySetInnerHTML={{ __html: plainText }} />
)

export default Code
